<template>
  <el-dialog :title="title"
             :visible.sync="dialogVisible"
             :close-on-click-modal="false"
             width="600px"
             @close="handleClose">
    <div class="mian">
      <div class="mian-status">
        <div class="icon">
          <i :class="title == '支付成功'  ? 'el-icon-success' : 'el-icon-error'"
             :style="{color: title == '支付成功' ? '#14C855' : '#E72F0D'}"></i>
          <p>{{title}}</p>
        </div>
        <div class="info">
          <p>支付方式：{{code=='AliPay'?'支付宝':'微信'}} </p>
          <p>订单号： {{order_sn}}</p>
          <p>支付金额： {{order_amount}}</p>
        </div>
        <div class="int-btn">
          <el-button type="primary"
                     @click="handleClick(1)">返回</el-button>
          <el-button @click="handleClick(2)" v-if="formCode !=3">查看详情</el-button>

        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  inject:['reload'],
  props: {
    title: {
      require: true,
    },
    order_amount: {
      require: true,
    },
    order_sn: {
      require: true,
    },
    code: {
      require: true,
    },
    formCode:{
      type:Number
    }
  },
  data () {
    return {
      dialogVisible: true
    };
  },
  methods: {
    handleClose () {
      this.$emit('handleClose')
    },
    handleClick (num) {
      num == 1 ?  this.reload() : this.$router.push('/home/bill')
    },
  },
  components: {

  },
};
</script>

<style scoped lang="scss">
.mian {
  width: 100%;
  height: 420px;
  .mian-status {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .icon {
      font-size: 100px;
      //  text-align: center;
      margin-bottom: 20px;
      p {
        font-size: 18px;
        margin: 20px 0;
        text-align: center;
      }
    }
    .info {
      font-size: 16px;
      p {
        padding: 10px 0;
      }
    }
  }
  .int-btn {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    width: 300px;
    ::v-deep .el-button {
      width: 160px;
      height: 32px;
    }
    ::v-deep .el-button--primary {
      color: #fff;
      background-color: #2448ff;
      border-color: #2448ff;
    }
  }
}
</style>
